import axios from "axios";

const axiosInstance = axios.create({
  baseURL: (import.meta as any).env.VITE_BASE_URL,
  headers: {
    "ngrok-skip-browser-warning": "abc",
  },
});
// instance.interceptors.request.use(async (config: any) => {
//   const { idToken }: any = (await fetchAuthSession()).tokens ?? {};
//   if (idToken && config.headers) {
//     config.headers = {
//       // Authorization: `Bearer ${idToken}`,
//       "ngrok-skip-browser-warning": "abc",
//     };
//   }
//   return config;
// });

export default axiosInstance;
